module.exports = __webpack_public_path__ + "14d00dab1f6802e787183ecab5cce85e.ttf";